import { type Theme } from '@logto/schemas';

type Props = {
  readonly className?: string;
  readonly theme: Theme;
};

/**
 * The "Powered by Logto" signature is intentionally disabled for this
 * self-hosted deployment. The component is kept (with its props) so the
 * layouts that render it need no changes; it simply renders nothing, which
 * also removes the integrity guard style, MutationObserver and interval the
 * original component installed.
 */
const LogtoSignature = (_props: Props) => null;

export default LogtoSignature;
